<template>
  <Popup :ref="(el) => popup = el"
         :title="$t('labels.invite_url')"
         @onClose="hide"
  >
    <form>
      <div class="popup__content mb-sm">
        <div class="d-flex gap-sm">
          <div class="" style="overflow: hidden;text-overflow: ellipsis; white-space: nowrap;">
            <a :href="url" target="_blank">
              <small>{{ url }}</small>
            </a>
          </div>
          <copy-button :value="url"></copy-button>
        </div>
      </div>
      <div class="popup__controls">
        <button @click="hide()" type="button" class="btn btn--accept">
          <span class="text-capitalize-first">{{ $t('button.ok') }}</span>
        </button>
      </div>
    </form>
  </Popup>
</template>
<script lang="ts">
import {computed, defineComponent, ref} from 'vue'
import {reactive, toRefs} from '@vue/reactivity';
import Popup from "@/apps/public/components/Popup.vue";
import {$t, helper} from "@/service/CommonHelper";
import FormInputWrapper from "@/components/FormInputWrapper.vue";
import LoaderButton from "@/apps/public/components/LoaderButton.vue";
import CopyButton from "@/apps/public/components/CopyButton.vue";

export default defineComponent({
  methods: {$t},
  components: {CopyButton, LoaderButton, FormInputWrapper, Popup},
  setup() {

    const popup = ref<InstanceType<typeof Popup> | null>(null)

    const state = reactive({
      url: '' as string
    });

    const show = (url: string) => {
      state.url = url
      popup.value?.show()
    }

    const hide = () => {
      popup.value?.hide()
    }

    return {
      ...toRefs(state),
      popup,
      helper,
      show,
      hide,
    }
  }
})
</script>
